import React from 'react';
import { X, Crown, Check } from 'lucide-react';
import { Link } from 'react-router-dom';

const PaywallDialog = ({ open, onClose, trigger = 'hand_limit' }) => {
  if (!open) return null;

  const messages = {
    hand_limit: {
      title: 'Daily Hand Limit Reached',
      description: 'You have played all 10 free hands for today. Upgrade to Premium for unlimited hands!',
      icon: '🎴'
    },
    premium_content: {
      title: 'Premium Content',
      description: 'This content is available for Premium members only.',
      icon: '🔒'
    },
    ai_limit: {
      title: 'AI Coach Limit Reached',
      description: 'Upgrade to Premium for unlimited AI coaching sessions.',
      icon: '🤖'
    }
  };

  const message = messages[trigger] || messages.hand_limit;

  const premiumFeatures = [
    'Unlimited poker hands per day',
    'Full AI coaching access',
    'Premium video content',
    'Advanced analytics dashboard',
    'Priority tournament seats',
    'Ad-free experience'
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm" data-testid="paywall-dialog">
      <div className="w-full max-w-2xl m-4 bg-gradient-to-br from-[#121923] to-[#0A241C] border-2 border-[#C9A227] rounded-2xl shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="relative bg-gradient-to-r from-[#C9A227] to-[#E1C25B] p-8 text-[#0B0F14]">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 hover:bg-black/10 rounded-lg transition-colors"
            data-testid="close-paywall-btn"
          >
            <X className="w-5 h-5" />
          </button>
          
          <div className="text-center">
            <div className="text-5xl mb-3">{message.icon}</div>
            <h2 className="text-3xl font-heading font-bold mb-2">{message.title}</h2>
            <p className="text-[#0B0F14]/80 text-lg">{message.description}</p>
          </div>
        </div>

        {/* Content */}
        <div className="p-8">
          <div className="flex items-center gap-3 mb-6">
            <Crown className="w-8 h-8 text-[#C9A227]" />
            <h3 className="text-2xl font-heading font-bold">Premium Membership</h3>
            <div className="ml-auto">
              <span className="text-3xl font-bold text-[#C9A227]">$19.95</span>
              <span className="text-foreground/60">/month</span>
            </div>
          </div>

          {/* Features List */}
          <div className="space-y-3 mb-8">
            {premiumFeatures.map((feature, idx) => (
              <div key={idx} className="flex items-start gap-3">
                <div className="w-5 h-5 rounded-full bg-[#C9A227] flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check className="w-3 h-3 text-[#0B0F14]" />
                </div>
                <span className="text-foreground/90">{feature}</span>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="space-y-3">
            <Link
              to="/membership"
              className="block w-full py-4 bg-[#C9A227] hover:bg-[#E1C25B] text-[#0B0F14] rounded-xl font-heading font-bold text-lg text-center transition-colors"
              data-testid="upgrade-to-premium-btn"
            >
              Upgrade to Premium
            </Link>
            <button
              onClick={onClose}
              className="block w-full py-3 bg-[#1A2432] hover:bg-[#1A2432]/70 text-foreground rounded-xl font-semibold transition-colors"
              data-testid="continue-free-btn"
            >
              Continue with Free
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaywallDialog;
